import React, { useState, useRef } from "react";
import { Modal } from "react-bootstrap";
import "./DashboradMedicalModal.css";
import examImg from "../assets/images/state-img.png";
//Import Footer SVg
import { ExamCardSVG } from '../components/SvgIcons';

const examList = [
  { name: "AIPAPGET Ayurveda", selected: true },
  { name: "CRAV", selected: false },
  { name: "UPSC AMO", selected: false },
  { name: "UPSC AMO", selected: false },
  { name: "UPSC AMO", selected: false },
];

const ChangeExamCategoryPage = ({ show, onHide }) => {
  const isMobile = window.innerWidth < 576;

  const [sheetHeight, setSheetHeight] = useState(90);
  const [isDragging, setIsDragging] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);

  const startY = useRef(0);
  const startHeight = useRef(75);

  /* ---------- Drag Handlers (Mobile Only) ---------- */
  const handleDragStart = (e) => {
    if (!isMobile) return;
    setIsDragging(true);
    startY.current = e.touches[0].clientY;
    startHeight.current = sheetHeight;
  };

  const handleDragMove = (e) => {
    if (!isMobile || !isDragging) return;
    const delta = startY.current - e.touches[0].clientY;
    let nextHeight = startHeight.current + delta / 3;
    nextHeight = Math.max(40, Math.min(90, nextHeight));
    setSheetHeight(nextHeight);
  };

  const handleDragEnd = () => {
    if (!isMobile) return;
    setIsDragging(false);

    if (sheetHeight < 55) onHide();
    else if (sheetHeight < 70) setSheetHeight(70);
    else setSheetHeight(90);
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop
      dialogClassName="exam-category-modal"
    >
      <div
        className="modal-content-custom"
        style={
          isMobile
            ? {
                height: `${sheetHeight}vh`,
                transition: isDragging
                  ? "none"
                  : "height 0.35s cubic-bezier(0.33, 1, 0.68, 1)",
              }
            : {}
        }
      >
        {/* Header */}
        <div
          className="modal-header-custom"
          onTouchStart={handleDragStart}
          onTouchMove={handleDragMove}
          onTouchEnd={handleDragEnd}
        >
          {isMobile && <div className="drag-handle" />}
          <h5 className="fw-bold">Select Any One Medical Exam</h5>
          {!isMobile && (
            <button className="close-btn" onClick={onHide}>
              <i className="bi bi-x"></i>
            </button>
          )}
        </div>

        {/* Body */}
        <div className="modal-body-custom medical-list">
          {examList.map((item, index) => (
            
            <div
              key={index}
              className={`medical-card ${
                activeIndex === index ? "active" : ""
              }`}
              onClick={() => setActiveIndex(index)}
            >
                <div className="exam-card-bg">
                  <ExamCardSVG />
               </div>
         <div className="exam-card-content  d-flex align-items-center justify-content-between w-100">
              <div className="left">
                <img src={examImg} alt="" />
                <span className="item-title fw-bold">{item.name}</span>
              </div>
               <span className="chevron-btn">
                <i className="bi bi-chevron-right"></i>
              </span>
              </div>
            </div>
          ))}
        </div>

        {/* Footer */}
        <div className="modal-footer-custom">
          <button className="add-btn fw-bold">Continue</button>
        </div>
      </div>
    </Modal>
  );
};

export default ChangeExamCategoryPage;
